import { Dialog, DialogProps, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { MobileDrawer } from 'src/Elements/Drawer'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  dialogWrapper: {
    '&  .MuiDialog-paper': {
      height: '100%',
      maxHeight: '800px',
      margin: 0,
      padding: 0,
    },
  },
  drawerPaper: {
    '& .MuiDrawer-paper': {
      background: theme.palette.common.white,
      borderRadius: `${theme.spacing(2)} ${theme.spacing(2)} 0  0`,
      margin: 0,
      top: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      display: 'flex',
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
  },
}))

type Props = {
  children: React.ReactNode
  modalMaxWidth?: DialogProps['maxWidth']
  isOpen?: boolean
  onClose?: () => void
  containerStyle?: string
  closableOnlyWithActionButtons?: boolean
}

/*
 * A responsive container that renders a modal drawer on mobile and a modal on desktop.
 */
const ResponsiveModalDrawerContainer: React.FC<Props> = ({
  isOpen = true,
  onClose = () => undefined,
  children,
  modalMaxWidth = 'lg',
  containerStyle,
  closableOnlyWithActionButtons,
}) => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const { classes, cx } = useStyles()

  if (downSm)
    return (
      <MobileDrawer
        onClose={onClose}
        open={isOpen}
        containerStyle={cx(classes.drawerPaper, containerStyle)}
        closableOnlyWithActionButtons={closableOnlyWithActionButtons}
      >
        {children}
      </MobileDrawer>
    )
  else
    return (
      <Dialog maxWidth={modalMaxWidth} fullWidth open={isOpen} onClose={onClose} className={cx(classes.dialogWrapper, containerStyle)}>
        {children}
      </Dialog>
    )
}

export default ResponsiveModalDrawerContainer
